import { createSelector } from 'reselect';

import { categoryNameToUrl } from 'utils/format';

import { getData } from 'redux/modules/taxonomy/selectors';

const getCategoryId = (state, categoryId) => categoryId;

const getTaxonomyNodeByCategoryId = createSelector(
  [getData, getCategoryId],
  (data, categoryId) => data[categoryId],
);

const getTaxonomyName = createSelector([getTaxonomyNodeByCategoryId], taxonomyNode =>
  taxonomyNode ? taxonomyNode.name : taxonomyNode,
);

export const offerCategorySegment = createSelector([getTaxonomyName], taxonomyName =>
  taxonomyName ? `${categoryNameToUrl(taxonomyName).toLowerCase()}_offers` : taxonomyName,
);
